import React, { useState, useEffect } from 'react';
import { Box, Typography, Drawer, IconButton, Button  } from '@mui/material';

import { useMediaQuery } from "@mui/material";

import { collection, onSnapshot, doc, getDocs,setDoc, writeBatch, deleteDoc, updateDoc, addDoc, query, where } from 'firebase/firestore';
import {db} from '../../firebaseConfig';

import CloseIcon from '@mui/icons-material/Close';

import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

import EditIcon from '@mui/icons-material/EditOutlined';

import PdfThumbnail from '../../images/PdfThumbnail.png'; // import a component or image for PDF thumbnail
import GenericFileThumbnail from '../../images/GenericFileThumbnail.png'; // import a component or image for generic file thumbnail

import { useTheme } from "@mui/material";

import { tokens } from "../../theme";

import { useUser } from "../../common/UserContext";
import { useApplicationMode } from "../../common/ApplicationModeContext";



    const generateAssociatedCauseColorMapDrawer = (beneficiaries, causesMap,theme) => {

    const associatedCauseIdColorMap = {};
    
    const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
    
    beneficiaries.forEach(beneficiary => {
        if (!associatedCauseIdColorMap[beneficiary.associatedCauseId]) {
        associatedCauseIdColorMap[beneficiary.associatedCauseId] = colorFunction(beneficiary.associatedCauseId);
        }
    });
    
    return associatedCauseIdColorMap;
    };
    
const generateGenderColorMapDrawer = (beneficiaries,theme) => {
  
        const genderColorMap = {};
        
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;

        beneficiaries.forEach(beneficiary => {
          if (!genderColorMap[beneficiary.gender]) {
            genderColorMap[beneficiary.gender] = colorFunction(beneficiary.gender);
          }
        });
      
        return genderColorMap;
      };
      

    const generateUniqueNeedsColorMapDrawer = (beneficiaries,theme) => {
        const uniqueNeedsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        for (const beneficiary of beneficiaries)
        {
            if (beneficiary.uniqueNeeds != null)
            {
               for (const itemId of beneficiary.uniqueNeeds)
               {
                    const item = itemId;
                    if (item && !uniqueNeedsColorMap[item]) {
                        uniqueNeedsColorMap[item] = colorFunction(item);
                    }
                }
            }
        }
        return uniqueNeedsColorMap;
      };
      

    const generateAssociatedEventColorMapDrawer = (beneficiaries, eventsMap,theme) => {

    const associatedEventIdColorMap = {};
    
    const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
    
    beneficiaries.forEach(beneficiary => {
        if (!associatedEventIdColorMap[beneficiary.associatedEventId]) {
        associatedEventIdColorMap[beneficiary.associatedEventId] = colorFunction(beneficiary.associatedEventId);
        }
    });
    
    return associatedEventIdColorMap;
    };
    

    const generateAssociatedDonationIdsColorMapDrawer = (beneficiaries, AssociatedDonationIdsMap,theme) => {
        const associatedDonationIdsColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        beneficiaries.forEach(beneficiary => {
          (beneficiary.associatedDonationIds || []).forEach(itemId => {
            const item = AssociatedDonationIdsMap[itemId];
            if (item && !associatedDonationIdsColorMap[item]) {
                associatedDonationIdsColorMap[item] = colorFunction(item);
            }
          });
        });
        return associatedDonationIdsColorMap;
      };
      

    const generateSuccessStoriesColorMapDrawer = (beneficiaries,theme) => {
        const successStoriesColorMap = {};
        const colorFunction = theme.palette.mode === "dark" ? stringToColorDark : stringToColorLight;
        for (const beneficiary of beneficiaries)
        {
            if (beneficiary.successStories != null)
            {
               for (const itemId of beneficiary.successStories)
               {
                    const item = itemId;
                    if (item && !successStoriesColorMap[item]) {
                        successStoriesColorMap[item] = colorFunction(item);
                    }
                }
            }
        }
        return successStoriesColorMap;
      };
      



const stringToColorLight = (str) => {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  let color = '#';
  for (let i = 0; i < 3; i++) {
    const value = (hash >> (i * 8)) & 0xFF;
    // Ensuring that the color values are always light by adding a base value of 127
    const lightValue = ((value + 127) % 128) + 127;
    color += ('00' + lightValue.toString(16)).substr(-2);
  }
  return color;
};


const stringToColorDark = (str) => {
  
  return stringToColorLight(str); // We will use the same colors
};


const BeneficiaryDrawerModal = ({ drawerOpen, handleDrawerClose,handleArrowUpClick,handleArrowDownClick, selectedBeneficiary, beneficiaries, handleOpenEdit }) => {

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const { appUserAccountNumber } = useUser();
  const { applicationMode } = useApplicationMode();
    
  const data = selectedBeneficiary;

  const [associatedCauseMap, setAssociatedCauseMap] = useState({});
const [associatedEventMap, setAssociatedEventMap] = useState({});
const [associatedDonationIdsMap, setAssociatedDonationIdsMap] = useState({});

  
  
                const formatAssociatedCause = value => {

                    let formattedAssociatedCause = "";

                    if (value != null && value !=="")
                    {
                    formattedAssociatedCause = associatedCauseMap[value];
                    }
                    
                    return formattedAssociatedCause;
                };
    
                

                const formatAssociatedEvent = value => {

                    let formattedAssociatedEvent = "";

                    if (value != null && value !=="")
                    {
                    formattedAssociatedEvent = associatedEventMap[value];
                    }
                    
                    return formattedAssociatedEvent;
                };
    
                

                const formatAssociatedDonationIds = value => {

                    let formattedAssociatedDonationIds = "";

                    if (value != null)
                    {
                    formattedAssociatedDonationIds = (value|| []).map(id => associatedDonationIdsMap[id]).join(', ') || '';
                    }
                    
                    return formattedAssociatedDonationIds;
                };
                              
                

  
  
    useEffect(() => {
        const fetchStaticData = async () => {
            	const associatedCauseSnapshot = await getDocs(query(collection(db, "charitableCauses"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedCauseData = associatedCauseSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedCauseMap = associatedCauseData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedCauseMap(associatedCauseMap);

	const associatedEventSnapshot = await getDocs(query(collection(db, "events"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedEventData = associatedEventSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedEventMap = associatedEventData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.title }), {});
	setAssociatedEventMap(associatedEventMap);

	const associatedDonationIdsSnapshot = await getDocs(query(collection(db, "donations"), where("appAccountNumber", "==", appUserAccountNumber),where("applicationMode", "==", applicationMode)));
	const associatedDonationIdsData = associatedDonationIdsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
	const associatedDonationIdsMap = associatedDonationIdsData.reduce((acc, ref) => ({ ...acc, [ref.id]: ref.amount }), {});
	setAssociatedDonationIdsMap(associatedDonationIdsMap);



        };

        fetchStaticData();
      }, []);
    
    

  const [associatedCauseColorMap, setAssociatedCauseColorMap] = useState({});
const [genderColorMap, setGenderColorMap] = useState({});
const [uniqueNeedsColorMap, setUniqueNeedsColorMap] = useState({});
const [associatedEventColorMap, setAssociatedEventColorMap] = useState({});
const [associatedDonationIdsColorMap, setAssociatedDonationIdsColorMap] = useState({});
const [successStoriesColorMap, setSuccessStoriesColorMap] = useState({});
const [acknowledgementReceivedColorMap, setAcknowledgementReceivedColorMap] = useState({});


//USE EFFECT TO CHANGE COLOR MAP when it changes
useEffect(() => {
  setAssociatedCauseColorMap(generateAssociatedCauseColorMapDrawer(beneficiaries, associatedCauseMap,theme));
setGenderColorMap(generateGenderColorMapDrawer(beneficiaries,theme));
setUniqueNeedsColorMap(generateUniqueNeedsColorMapDrawer(beneficiaries, theme));
setAssociatedEventColorMap(generateAssociatedEventColorMapDrawer(beneficiaries, associatedEventMap,theme));
setAssociatedDonationIdsColorMap(generateAssociatedDonationIdsColorMapDrawer(beneficiaries, associatedDonationIdsMap,theme));
setSuccessStoriesColorMap(generateSuccessStoriesColorMapDrawer(beneficiaries, theme));


}, [theme.palette.mode, drawerOpen, beneficiaries ,associatedDonationIdsMap]);


  const formatFirestoreDate = timestamp => {

    if (timestamp != null && timestamp !== "")
    {
      const dateStr = new Date(timestamp.seconds * 1000).toISOString().slice(0, 10);
      const parts = dateStr.split('-');
      return `${parts[1]}/${parts[2]}/${parts[0]}`;
    } else 
    {
      return "";
    }
  };

  const formatFirestoreTime = timestamp => {

   if (timestamp != null && timestamp !== "")
   { 
        // Convert the seconds since Unix epoch to a Date object
      const date = new Date(timestamp.seconds * 1000);

      // Extract hours and minutes
      let hours = date.getHours();
      const minutes = date.getMinutes();

      // Determine AM or PM
      const period = hours >= 12 ? 'PM' : 'AM';

      // Convert hours to 12-hour format
      hours = hours % 12;
      hours = hours ? hours : 12; // the hour '0' should be '12'

      // Format hours and minutes as a time string in "hh:mm AM/PM" format
      const formattedHours = hours.toString().padStart(2, '0');
      const formattedMinutes = minutes.toString().padStart(2, '0');

      return `${formattedHours}:${formattedMinutes} ${period}`;
   } else
   {
    return "";
   }
  };


  const formatPhoneNumber = value => {
    if (!value) return value;
    const phoneNumber = value.replace(/[^\d]/g, '');
    const phoneNumberLength = phoneNumber.length;
    if (phoneNumberLength < 4) return phoneNumber;
    if (phoneNumberLength < 7) return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
  };

  const formatCurrencyInteger = value => {
  
    if (value != null && value !=="")
    {
      return `$${Number(value).toLocaleString()}`;
    } else 
    {
      return "";
    }
  };

  const formatCurrency = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `$${result}` : '';

      } else 
      {
        return "";
      }
  };


  const formatDecimal = (value) => {

    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9.]/g, '');
        
          // If there are multiple decimal points, keep only the first one
          const parts = result.split('.');
          if (parts.length > 2) {
            result = parts[0] + '.' + parts.slice(1).join('');
          }
        
          // Allow at most two decimal places
          if (parts.length === 2 && parts[1].length > 2) {
          
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1].substring(0, 2);
          } else if (parts.length === 2 && parts[1].length <= 2) 
          {
            result = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
          }else
          {
            result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          }
          return result ? `${result}` : '';
  
      } else 
      {
        return "";
      }
  };
  
  
  const formatInteger = (value) => {
  
    if (value != null && value !=="")
    {
          value = value.toString();
          // Remove all non-numeric characters except for the decimal point
          let result = value.replace(/[^0-9]/g, '');
        
          result = result.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          
          return result ? `${result}` : '';
  
      } else 
      {
        return "";
      }
  };


  const getFileExtension = (fileName) => {
    return fileName.split('.').pop().toLowerCase();
  };

  const renderFile = (fileContent,fileName) => {
    if (!fileContent || !fileName) return null;
    const fileType = getFileExtension(fileName);
    if (fileType === 'pdf') {
      return <img src={PdfThumbnail} title={fileName} alt="PDF thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'81px' }} />;
    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      return <img src={fileContent} title={fileName} alt="Profile thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer', maxWidth: '400px', maxHeight: '400px' }} />;
    } else {
      return <img src={GenericFileThumbnail} title={fileName} alt="File thumbnail" onClick={() => handleFileClick(fileType,fileContent,fileName)} style={{ cursor: 'pointer',height:'100px',width:'77px'  }} />;
    }
  };

  const handleFileClick = (fileType,fileContent,fileName) => {
    if (fileType === 'pdf') {
      
      const base64String = fileContent.split(',')[1]; // Extract base64 string from data URL
      const byteCharacters = atob(base64String);
      const byteNumbers = new Array(byteCharacters.length);
  
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
  
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);
  
      window.open(blobUrl, '_blank');

    } else if (['jpg', 'jpeg', 'png', 'gif'].includes(fileType)) {
      const image = new Image();
      image.src = fileContent;
    
      image.onload = () => {
        let width = image.naturalWidth;
        let height = image.naturalHeight;
        const padding = 50;
    
        // Get browser window dimensions
        const maxWidth = window.innerWidth - padding;
        const maxHeight = window.innerHeight - padding;
    
        // Resize the image if it's larger than the browser window
        if (width > maxWidth || height > maxHeight) {
          const widthRatio = maxWidth / width;
          const heightRatio = maxHeight / height;
          const minRatio = Math.min(widthRatio, heightRatio);
    
          width = Math.floor(width * minRatio);
          height = Math.floor(height * minRatio);
        }
    
        // Calculate the position to center the window
        const left = (window.screen.width / 2) - (width / 2);
        const top = (window.screen.height / 2) - (height / 2);
    
        // Open the window with the calculated position and size
        const w = window.open("", "", `width=${width + padding},height=${height + padding},left=${left},top=${top}`);
        image.style.width = `${width}px`;
        image.style.height = `${height}px`;
        w.document.write(image.outerHTML);
      };
        
    } else {
      const link = document.createElement('a');
      link.href = fileContent;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  

    return (
        <Drawer anchor="right" open={drawerOpen} onClose={handleDrawerClose}>
          <div>
          <Box sx={{ width: 600, padding: 2, backgroundColor:colors.drawerModalBackgroundColor, height: '100%', minHeight: '100vh'  }}>
            <Box display="flex" justifyContent="space-between" alignItems="center">

              {handleArrowDownClick ? (
              <Box display="flex">
                <IconButton onClick={handleArrowUpClick}>
                  <KeyboardArrowUpIcon />
                </IconButton>
                <IconButton onClick={handleArrowDownClick}>
                  <KeyboardArrowDownIcon />
                    </IconButton>
                </Box>

              ) : (
                <Box display="flex">
                  &nbsp;
                </Box>
              )}

                <IconButton onClick={handleDrawerClose}>
                  <CloseIcon />
                </IconButton>
              </Box>
              
                {selectedBeneficiary && (
                    <>
                      <h1>{data.id}</h1>
    <Button variant="contained" color="primary" sx={{ float:'right',backgroundColor: colors.greenAccent[600], color: colors.grey[100], '&:hover': { backgroundColor: colors.greenAccent[800] } }} onClick={() => handleOpenEdit(selectedBeneficiary.id)}>
        <EditIcon /> &nbsp; EDIT BENEFICIARY
    </Button>
                    
     <Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>FIRST NAME:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{data.firstName ? data.firstName.toString() : ""}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>LAST NAME:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{data.lastName ? data.lastName.toString() : ""}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>CAUSES:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                           <Box
                                key={data.associatedCauseId}
                                sx={{ 
                                    backgroundColor: associatedCauseColorMap[data.associatedCauseId], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    {associatedCauseMap[data.associatedCauseId]}

                                </Box>
                        </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>DATE OF BIRTH:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatFirestoreDate(data.dateOfBirth)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>GENDER:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                    <Box
                                key={data.gender}
                                sx={{ 
                                    backgroundColor: genderColorMap[data.gender], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    { data.gender ? data.gender.toString() : "" }

                                </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>CONTACT INFORMATION:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{data.contactInfo ? data.contactInfo.toString() : ""}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>UNIQUE NEEDS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                            <Box>
                            {(data.uniqueNeeds || []).map(value => (
                                <Box
                                key={value}
                                sx={{ 
                                    backgroundColor: uniqueNeedsColorMap[value], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000' ,
                                    fontWeight:'600' 
                                }}
                                >
                                {value.replaceAll("_"," ")}
                                </Box>
                            ))}
                            </Box>
                        </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>EVENTS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                           <Box
                                key={data.associatedEventId}
                                sx={{ 
                                    backgroundColor: associatedEventColorMap[data.associatedEventId], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                    fontWeight:'600'  
                                }}
                                >
                                    {associatedEventMap[data.associatedEventId]}

                                </Box>
                        </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>DONATIONS:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                        <Box>
                        {(data.associatedDonationIds || []).map(id => (
                            <Box
                            key={id}
                            sx={{ 
                                backgroundColor: associatedDonationIdsColorMap[associatedDonationIdsMap[id]], 
                                borderRadius: '13px', 
                                padding: '2px 8px', 
                                display: 'inline-block', 
                                marginRight: '4px',
                                marginBottom: '4px',
                                color: theme.palette.mode === "dark" ? '#000000' : '#000000',
                                fontWeight:'600' 
                            }}
                            >
                            {associatedDonationIdsMap[id]}
                            </Box>
                        ))}
                        </Box>
                    </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>PHOTO:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                {renderFile(data.photo,data.photoFileName)}
            </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>SUCCESS STORIES:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>

                            <Box>
                            {(data.successStories || []).map(value => (
                                <Box
                                key={value}
                                sx={{ 
                                    backgroundColor: successStoriesColorMap[value], 
                                    borderRadius: '13px', 
                                    padding: '2px 8px', 
                                    display: 'inline-block', 
                                    marginRight: '4px',
                                    marginBottom: '4px',
                                    color: theme.palette.mode === "dark" ? '#000000' : '#000000' ,
                                    fontWeight:'600' 
                                }}
                                >
                                {value.replaceAll("_"," ")}
                                </Box>
                            ))}
                            </Box>
                        </Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>MONTHLY SUPPORT AMOUNT:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
{formatCurrency(data.monthlySupportAmount)}</Typography>
</Box><hr/><Box style={{paddingTop:'10px',paddingBottom:'10px'}}><Box>ACKNOWLEDGMENT RECEIVED:</Box> <Typography variant='h6' sx={{fontWeight:'600'}}>
</Typography>
</Box><hr/>
                    </>
                )}
            </Box>
            </div>
        </Drawer>
    );
};

export default BeneficiaryDrawerModal;
